<template>
  <el-dialog
    title="创建工单"
    :visible.sync="dialogFormVisible"
    width="620px"
    :close-on-click-modal="false"
    @close="cancel"
  >
    <el-form
      label-position="right"
      label-width="110px"
      ref="workForm"
      :rules="rules"
      :model="workForm"
    >
      <el-form-item label="设备序列号" prop="sn">
        <el-input
          v-model="workForm.sn"
          placeholder="请输入设备序列号"
          :disabled="true"
          style="width: 300px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="工单标题" prop="title">
        <el-input v-model="workForm.title" placeholder="请输入工单标题" style="width: 300px;"></el-input>
      </el-form-item>
      <el-form-item label="工单类型 " prop="matterCategory">
        <el-select v-model="workForm.matterCategory" style="width: 300px;" @change="selectTypeCode">
          <el-option
            :key="item.matterCategory"
            v-for="item in typeList"
            :value="item.matterCategory"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="工单来源" prop="customer">
        <el-select v-model="workForm.customer" style="width: 300px;">
          <el-option
            :key="item.customer"
            v-for="item in sourceList"
            :value="item.customer"
            :label="item.customer"
          ></el-option>
        </el-select>
      </el-form-item>-->
      <!-- <el-form-item label="提单人" prop="customerName">
        <el-select v-model="workForm.customerName" style="width: 300px;">
          <el-option
            :key="item.customerName"
            v-for="item in manageList"
            :value="item.customerName"
            :label="item.customerName"
          ></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item label="工单级别" prop="level">
        <el-radio-group v-model="workForm.level">
          <el-radio :label="1">一级</el-radio>
          <el-radio :label="2">二级</el-radio>
          <el-radio :label="3">三级</el-radio>
          <el-radio :label="4">四级</el-radio>
          <el-radio :label="5">五级</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="省市区" prop="selectList">
        <el-cascader
          :options="addressList"
          style="width: 300px;"
          :props="commodityProps"
          v-model="workForm.selectList"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" prop="address">
        <el-input
          v-model="workForm.address"
          type="textarea"
          :rows="3"
          style="width: 300px;"
          placeholder="请输入详细地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="customerPhone">
        <el-input v-model="workForm.customerPhone" placeholder="请输入客户联系电话" style="width: 300px;"></el-input>
      </el-form-item>
      <el-form-item label="内容描述" prop="description">
        <el-input
          v-model="workForm.description"
          type="textarea"
          :rows="3"
          style="width: 300px;"
          placeholder="设备具体情况"
        ></el-input>
      </el-form-item>
      <el-form-item label="上传附件">
        <el-upload
          class="avatar-uploader"
          :multiple="true"
          :limit="3"
          :action="updateAction"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <div v-for="(item,index) in fileList" :key="index" style="float:left">
            <img :src="item" class="avatar" />
          </div>
          <i v-if="fileList.length<3" class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button :loading="loading" type="primary" @click="submit">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import axios from 'axios'
import { getAddressList } from "../../assets/js/area";
export default {
  props: {
    dialogShow: {
      type: Boolean,
      required: false
    },
    loading: {
      type: Boolean,
      required: false
    },
    edit: {
      type: Boolean,
      required: false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      rules: {
        sn: [{ trigger: 'blur', required: true, message: '请输入设备序列号!' }],
        title: [{ trigger: 'blur', required: true, message: '请输入工单标题!' }],
        tId: [{ trigger: 'change', required: true, message: '请选择工单类型!' }],
        sId: [{ trigger: 'change', required: true, message: '请选择工单来源!' }],
        level: [{ trigger: 'change', required: true, message: '请选择工单级别!' }],
      },
      workForm: {
        nid: '',
        sn: '',
        title: '',
        typeCode: '',
        customerName: '',
        customerPhone: '',
        level: '',
        address: '',
        description: '',
        params: {},
        selectList: [],
        customer: '',
        matterCategory: '',
        matterid: 0
      },
      addressList: [],
      commodityProps: {
        value: 'label',
        label: 'label'
      },
      typeList: [{ matterCategory: 1, name: '故障' }, { matterCategory: 2, name: '维保' }, { matterCategory: 3, name: '反馈' }],
      sourceList: [{ sId: 0, customer: '系统' }, { sId: 1, customer: '电话' }, { sId: 2, customer: '微信' }, { sId: 3, customer: '邮件' }, { sId: 4, customer: '短信' }],
      manageList: [{ oId: 0, customerName: '普通用户' }],
      fileList: [],
      updateAction: this.$store.getters.getApiValue + "/product/uploadImage.do",
      imgWidth: 0,
      imgHeight: 0,
      dialogFormVisible: this.dialogShow
    }
  },
  watch: {
    dialogShow (newval, oldval) {
      this.dialogFormVisible = newval
    }
  },
  created () {
    this.$watch('dialogShow', () => {
      // 新增
      if (!this.edit) {
        var thiz = this
        this.workForm.nid = this.model.nid
        this.workForm.sn = this.model.sn
        this.workForm.matterid = this.model.fbid
        this.workForm.typeCode = this.model.typeCode
        this.workForm.matterCategory = this.model.matterCategory

        console.log('mdl', this.model)

      } else {
        // 修改
        // this.workForm.sn = this.model.sn
        // this.workForm.name = this.model.name
      }
      this.getSuggest(this.model)
    })
    this.addressList = getAddressList();
  },
  methods: {
    selectTypeCode (e) {
      const index = e
      const list = this.typeList
      this.workForm.typeCode = list[index - 1].name
      console.log(this.workForm)
    },

    getSuggest (model) {
      console.log('请求')
      // var mdl = this.model
      var thiz = this
      var params = {
        nid: model.nid,
        matterCategory: model.matterCategory,
      }
      if (model.fbid) {
        params['matterid'] = model.fbid
      }
      axios.get(this.$store.getters.getApiValue + '/maintain/getInfoByNid.do', {
        params: params,
      }).then(function (response) {
        var data = response.data.data
        if (data) {
          thiz.workForm.customerName = data.customerName
          thiz.workForm.customer = data.customer
          thiz.workForm.customerPhone = data.customerPhone
          if (data.params != '') {
            const image = data.params
            thiz.fileList = JSON.parse(image).images
            thiz.workForm.params = JSON.parse(image)
          }
          thiz.workForm.description = data.description
          thiz.workForm.address = data.fullAddress
          console.log('workForm', thiz.workForm)
        } else {
          thiz.$message.error(data.message)
        }
      }).catch(function (error) {
        thiz.$message.error('系统异常，请与管理员联系!')
        console.log(error)
      })
    },

    submit () {
      var thiz = this
      var workForm = this.workForm
      workForm.params.images = this.fileList
      var form = JSON.parse(JSON.stringify(workForm))
      var address = workForm.selectList
      if (address.length > 0) {
        form['province'] = address[0]
        form['city'] = address[1]
        form['district'] = address[2]
      } else {
        form['province'] = ''
        form['city'] = ''
        form['district'] = ''
      }
      delete form.selectList
      console.log(workForm)
      console.log(form)

      this.$refs["workForm"].validate(async valid => {
        if (valid) {
          // 提交后 重置表单
          thiz.workForm = {
            nid: '',
            sn: '',
            title: '',
            typeCode: '',
            customerName: '',
            customerPhone: '',
            level: '',
            address: '',
            description: '',
            params: {},
            selectList: [],
            customer: '',
            matterCategory: '',
            matterid: 0
          }
        }
        this.$emit('submit', valid, form, this.edit)
      })
    },
    cancel () {
      // console.log('关闭')
      this.$emit('cancel')
    },
    // handleRemove (file, fileList) {
    //   console.log(fileList);
    // },
    handleAvatarSuccess (res, file) {
      var images = this.fileList
      images.push(res.data)
      this.fileList = images
      console.log(this.fileList)
    },

    beforeAvatarUpload (file) { },
    setSize (e, maxWidth, maxHeight) {
      const width = e.target.naturalWidth
      const height = e.target.naturalHeight
      let wratio = width * 1.0 / maxWidth;
      let hratio = height * 1.0 / maxHeight;
      let ratio = width * 1.0 / height;
      if (wratio >= hratio) {
        this.imgWidth = maxWidth;
        this.imgHeight = this.imgWidth * 1.0 / ratio
      } else {
        this.imgHeight = maxHeight;
        this.imgWidth = this.imgHeight * ratio;
      }
    },
  },
}
</script>

<style scoped>
.el-radio {
  margin-right: 0 !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: 1px dotted #8c939d;
}

/* .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
} */

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.avatar {
  width: 50px;
  height: 50px;
  display: inline-block;
  margin-right: 10px;
}
</style>
